import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router';
import { Provider } from 'react-redux';
import ERP_Store from './redux/Store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter>
    <Provider store={ERP_Store}>
      <App />
    </Provider>
  </BrowserRouter>

);

